
import styles from './index.module.scss'
import { useRef, useMemo, useState, useEffect, useContext } from 'react'
import DefaultEmpytPage from './components/DefaultEmpytPage'
import Iconfont from '@utils/Iconfont';
import { ClockCircleOutlined, SyncOutlined } from '@ant-design/icons';
import ProListpageTop from './components/ProListpageTop'
import { Pagination, Button, Modal, Popover, message, Spin, Tabs, Checkbox, Empty } from 'antd';
import { AppContext } from '@utils/AppContext';
import { useNavigate } from 'react-router-dom';
import API from "@api/api";
import Utils from '@utils/utils';
import { BATCH_IMAGES_TYPE } from '@utils/CONST';
import PSAIModal from '@PSAIComponents/PSAIModal';

const BatchProductImages = (props) => {
    const { globalOrgInfo, globalUser } = useContext(AppContext)
    const { isProCenter } = props
    const navigate = useNavigate()
    const calculatePageSize = (isPro) => {
        const width = window.innerWidth;
        let targetTotalCards = 18; // 6列或3列时，总卡片数18能完美整除
        if (width > 1200 && width <= 1800) {
            targetTotalCards = 20; // 5列或4列时，总卡片数20能完美整除
        }
        // 如果不是专业中心，有一个"新建项目"卡片占据了一个位置，所以请求数量要减1
        return isPro ? targetTotalCards : targetTotalCards - 1;
    }

    const [total, setTotal] = useState(0)
    const [pageSize, setPageSize] = useState(calculatePageSize(isProCenter))

    useEffect(() => {
        let timer;
        const handleResize = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                setPageSize(prev => {
                    const newSize = calculatePageSize(isProCenter);
                    return prev !== newSize ? newSize : prev;
                });
            }, 300);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(timer);
        };
    }, [isProCenter]);

    const [pageIndex, setPageIndex] = useState()
    const [isFirstLoad, setIsFirstLoad] = useState(true)
    const [projectList, setProjectList] = useState([])
    const [loading, setLoading] = useState(true)
    const [createOpen, setCreateOpen] = useState(false)
    const [projectType, setProjectType] = useState('all')
    const [projectSerial, setProjectSerial] = useState('')
    const [proStatus, setProStatus] = useState('all')
    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')
    const [member, setMember] = useState(sessionStorage.getItem('batchProductImagesTabKey') == '2' ? null :
        (globalOrgInfo?.current?.role == 'admin' && isProCenter) ? globalUser?.id : null)
    const projectListRef = useRef([]) // 记录初始列表是否有值，避免筛选后列表为空

    const [isSelected, setIsSelected] = useState(false)
    const [selectedList, setSelectedList] = useState([])

    const isSelectedAll = useMemo(() => {
        if (projectList.length === 0) return false
        return projectList.every(item => selectedList.includes(item.id))
    }, [selectedList, projectList])

    const selectAll = () => {
        const currentPageIds = projectList.map(item => item.id)
        if (isSelectedAll) {
            setSelectedList(prev => prev.filter(id => !currentPageIds.includes(id)))
        } else {
            setSelectedList(prev => [...new Set([...prev, ...currentPageIds])])
        }
    }

    const selectCurrentItem = (id) => {
        if (selectedList.includes(id)) {
            setSelectedList(selectedList.filter(item => item !== id))
        } else {
            setSelectedList([...selectedList, id])
        }
    }

    useEffect(() => {
        setSelectedList([])
        setIsSelected(false)
    }, [projectType, proStatus, projectSerial, startTime, endTime, member, tabKey])

    useEffect(() => {
        setTimeout(() => {
            let index = sessionStorage.getItem('batchProductImagesPageIndex') || 1
            if (index) setPageIndex(Number(index))
            setIsFirstLoad(false)
        }, 100)
    }, [])

    const onChange = pageNumber => {
        sessionStorage.setItem('batchProductImagesPageIndex', pageNumber)
        setPageIndex(pageNumber)
    }

    const listBatchProject = () => {
        API.listBatchProject({
            pageIndex,
            pageSize,
            projectType: projectType == 'all' ? null : projectType,
            projectName: projectSerial,
            myProjectData: isProCenter ? true : false,
            status: proStatus == 'all' ? null : proStatus,
            startTime,
            endTime,
            member
        }).then(res => {
            if (res.code === 0) {
                if (res.data.items.length === 0 && pageIndex > 1) {
                    sessionStorage.removeItem('batchProductImagesPageIndex')
                    setPageIndex(1)
                    return
                }
                setProjectList([...res.data.items])
                setTotal(res.data.total || 0)
                if (projectListRef.current.length === 0) projectListRef.current = [...res.data.items] || []
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const haveTask = useMemo(() => {
        return member ? projectListRef.current?.length > 0 : true
    }, [projectList, member])

    useEffect(() => {
        if (!pageIndex) return
        if (!localStorage.getItem('token')) { setLoading(false); return }
        listBatchProject()
    }, [pageIndex, isProCenter, pageSize])

    useEffect(() => {
        if (isFirstLoad) return
        sessionStorage.removeItem('batchProductImagesPageIndex')
        setPageIndex(1)
        if (!localStorage.getItem('token')) { setLoading(false); return }
        if (pageIndex === 1) {
            listBatchProject()
        }
    }, [projectType, proStatus, projectSerial, startTime, endTime, member])

    // 再次发起一个新项目
    const regenerateByProject = (e, projectId) => {
        e.stopPropagation()
        API.regenerateByProject({
            projectId
        }).then(res => {
            if (res.code === 0) {
                navigate(`/home/product/${res.data}/config`, { state: { isProCenter } })
            } else message.error(res.message)
        })
    }

    const items = [
        { key: '1', label: '个人项目' },
        { key: '2', label: '企业项目成员' }
    ]
    const [tabKey, setTabKey] = useState(sessionStorage.getItem('batchProductImagesTabKey') || '1')
    const tabChange = key => {
        setPageIndex(1)
        setTabKey(key)
        sessionStorage.setItem('batchProductImagesTabKey', key)
    }

    useEffect(() => {
        if (!globalUser?.id) return
        if (tabKey == '1' && globalOrgInfo?.current?.role == 'admin' && isProCenter) {
            setMember(globalUser?.id)
        }
        if (tabKey == '2') setMember()
    }, [globalUser?.id, tabKey, isProCenter, globalOrgInfo])

    const showMemberSelect = useMemo(() => {
        return isProCenter && tabKey == '2'
    }, [tabKey, isProCenter])

    const shouldShowListLayout = useMemo(() => {
        if (!localStorage.getItem('token')) return false
        if (isProCenter) return true
        if (globalOrgInfo?.isPersonal) return false
        return haveTask && (projectList?.length > 0 || projectListRef.current?.length > 0)
    }, [globalOrgInfo?.isPersonal, isProCenter, haveTask, projectList])

    const Text = (type) => {
        return type == BATCH_IMAGES_TYPE.TRYON_BATCH ? 'AI试衣' :
            type == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '换模特' :
                type == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '换背景' :
                    type == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '同款换色' :
                        type == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? 'AI超清' :
                            type == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '去水印' :
                                type == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '搭配上身' :
                                    type == BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? '种草图' :
                                        type == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '服装详情页' :
                                            type == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? '图生视频' :
                                                ''
    }

    const deleteProject = (projectId) => {
        const projectIds = Array.isArray(projectId) ? projectId : [projectId]
        return API.batchRemoveProject({
            projectIds
        }).then((res) => {
            if (res?.code === 0) {
                message.success('删除成功');
                setSelectedList([])

                // 计算删除后的总数
                const remainingTotal = total - projectIds.length;
                // 计算最大页数
                const maxPage = Math.ceil(remainingTotal / pageSize);

                // 如果当前页超过了最大页数，且不是第一页，则回退一页
                if (pageIndex > maxPage && pageIndex > 1) {
                    const prevPage = pageIndex - 1;
                    sessionStorage.setItem('batchProductImagesPageIndex', prevPage);
                    setPageIndex(prevPage);
                } else {
                    listBatchProject();
                }
            } else {
                message.error('删除失败');
            }
        })
    };

    const deleteClick = () => {
        if (selectedList.length === 0) {
            message.warning('请先选择项目')
            return
        }
        PSAIModal.confirm({
            title: "删除项目",
            content: `确定删除这${selectedList.length}个项目吗？删除后将无法找回`,
            onOk: () => deleteProject(selectedList)
        })
    }

    return (
        <>
            {
                loading ? <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Spin size="large"></Spin>
                </div> :
                    shouldShowListLayout ? <>
                        <div className={styles.BatchProductImages} >
                            {
                                (globalOrgInfo?.current?.role == 'admin' && isProCenter) &&
                                <Tabs items={items} activeKey={tabKey} onChange={tabChange} style={{ width: '100%' }} />
                            }
                            <ProListpageTop
                                showMemberSelect={showMemberSelect}
                                isProCenter={isProCenter}
                                projectType={projectType}
                                proStatus={proStatus}
                                getProjectType={value => { setProjectType(value); setPageIndex(1); }}
                                getProjectSerial={setProjectSerial}
                                member={member}
                                getMember={setMember}
                                getProStatus={value => { setProStatus(value); setPageIndex(1); }}
                                getStartTime={value => { setStartTime(value); setPageIndex(1); }}
                                getEndTime={value => { setEndTime(value); setPageIndex(1); }}
                                getIsSelected={setIsSelected}
                                setSelectedList={setSelectedList}
                                selectedList={selectedList}
                                isSelectedAll={isSelectedAll}
                                selectAll={selectAll}
                                deleteClick={deleteClick}
                            />
                            <div
                                className={`${styles.ProjectListItems} _beauty_scrollbar`}
                                style={{ maxHeight: (globalOrgInfo?.current?.role == 'admin' && isProCenter) ? "calc(100% - 150px)" : "calc(100% - 90px)" }}>
                                {
                                    !isProCenter && <div className={`${styles.ItemBox} ${styles.NewProject}`}
                                        style={{ height: projectList.length == 0 ? '350px' : 'auto' }} >
                                        <Iconfont className={styles.iconfont} type="icon-newProjectOutlined" />
                                        <Button
                                            className={styles.NewProjectBtn} type="primary"
                                            onClick={() => setCreateOpen(true)}>新建项目</Button>
                                    </div>
                                }
                                {
                                    projectList.map((item) => (
                                        <div className={styles.ItemBox} key={item.id}
                                            onClick={() => {
                                                if (item.orgData && item.status === 0) {
                                                    message.warning('企业成员的草稿项目不可操作！', 3)
                                                    return
                                                }

                                                if (isSelected) return

                                                if (item.status === 0) {
                                                    navigate(`/home/product/${item.id}/config`, { state: { isProCenter } })
                                                } else {
                                                    navigate(`/home/product/${item.id}/detail`, { state: { isProCenter } })
                                                }
                                            }}>
                                            {
                                                isSelected &&
                                                <div className={styles.SelectMask} onClick={(e) => {
                                                    e.stopPropagation();
                                                    selectCurrentItem(item?.id)
                                                }}>
                                                    <Checkbox
                                                        className={styles.ItemSelect}
                                                        checked={selectedList.includes(item?.id)}
                                                    ></Checkbox >
                                                </div>
                                            }
                                            <div className={styles.ItemImg}>
                                                {
                                                    item.status === 4 ? <div className={styles.failMask}>
                                                        <Iconfont className={styles.iconfont} type="icon-imageErrorOutline" />
                                                        <p>生成失败</p>
                                                    </div> : item.skuImageList?.length > 0 ? <img src={Utils.getImgThumbnail(item.skuImageList[0])} alt="" /> : <div className={styles.failMask}>
                                                        <Iconfont className={styles.iconfont} type="icon-newProjectOutlined" />
                                                        <p>待传商品</p>
                                                    </div>
                                                }
                                                {item.status === 0 && <span className={styles.draft}><Iconfont style={{ marginRight: '4px' }} type="icon-draftOutline" />草稿</span>}
                                                {(item.unread === 1 && (item.status === 3 || item.status === 4)) && <span className={styles.readFlag}></span>}
                                                {
                                                    (item.status === 1 || item.status === 2) && <div className={styles.ItemMask}>
                                                        {item.status === 2 && <img src="https://photostudio-ai.oss-cn-hangzhou.aliyuncs.com/photostudio-web/admin/images_v3/loadingBlue.gif" />}
                                                        {item.status === 1 && <div className={styles.waitingMask}><ClockCircleOutlined className={styles.iconfont} /> <p>排队中</p></div>}
                                                    </div>
                                                }
                                            </div>
                                            <div className={styles.ItemName}>
                                                <p>
                                                    {Text(item?.projectType)}
                                                    <span style={{ marginLeft: '8px', fontSize: '18px' }}>{item?.projectName}</span>
                                                </p>
                                                {
                                                    !item.orgData && <div className={styles.iconfontWrap}>
                                                        <Iconfont className={styles.iconfont} type="icon-DeleteOutlined" onClick={(e) => {
                                                            e.stopPropagation();
                                                            PSAIModal.confirm({
                                                                title: "删除项目",
                                                                content: "删除后项目将无法找回，确定删除吗？",
                                                                onOk: () => deleteProject(item.id)
                                                            })
                                                        }} />
                                                        <Popover content={'再次发起'}>
                                                            <SyncOutlined onClick={(e) => regenerateByProject(e, item.id)} className={styles.iconfont} />
                                                        </Popover>
                                                    </div>
                                                }
                                            </div>
                                            <p className={styles.timeMessage}>{item?.memberName} <span>{item?.updatedTime}</span></p>
                                        </div>
                                    ))
                                }
                                {
                                    isProCenter && projectList.length === 0 && (
                                        <div className={styles.EmptyWrap}>
                                            <Empty description="暂无项目数据" />
                                        </div>
                                    )
                                }
                            </div>
                            <div className={styles.ProjectListPagination}>
                                <Pagination
                                    showQuickJumper
                                    total={total}
                                    onChange={onChange}
                                    pageSize={pageSize}
                                    current={pageIndex}
                                    showSizeChanger={false} />
                            </div>
                        </div>
                    </> : <DefaultEmpytPage />
            }
            <Modal
                open={createOpen}
                footer={null}
                width={1300}
                closable={false}
                maskClosable={true}
                style={{ padding: 0, minWidth: '852px' }}
                className={styles.CreateModal}
                onCancel={() => setCreateOpen(false)}
            >
                <div style={{
                    padding: '24px',
                    borderRadius: '24px',
                    backgroundColor: '#F6FAFF'
                }}>
                    <DefaultEmpytPage disabledTitle /></div>
            </Modal>
        </>
    )
}

export default BatchProductImages
